import React, { useEffect, useState } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';

interface InfoButtonProps {
  message: string;
}

const InfoButton: React.FC<InfoButtonProps> = ({ message }) => {
  const [showMessage, setShowMessage] = useState(false);

  const handleClick = () => {
    setShowMessage(true);
  };

  useEffect(() => {
    const handleMouseMovement = () => {
      if (showMessage) {
        setShowMessage(false);
      }
    };

    const handleScroll = () => {
      if (showMessage) {
        setShowMessage(false);
      }
    };

    window.addEventListener('mousemove', handleMouseMovement);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('mousemove', handleMouseMovement);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showMessage]);

  return (
    <div className="relative">
      <button
        onClick={handleClick}
        className="text-primary text-xl h-12 items-center ml-2 cursor-pointer"
      >
        <AiOutlineInfoCircle />
      </button>
      {showMessage && (
        <div className="bg-gray-200 text-gray-700 p-2 rounded-md absolute  ml-2 max-w-4xl z-50">
          {message}
        </div>
      )}
    </div>
  );
};

export default InfoButton;
